import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import CloseIcon from "@material-ui/icons/Close";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { Dropdown, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import {
  CancelButton,
  TextCancel,
  AlignButtonsCancel,
  ButtonCancelYes,
  ButtonCancelNo,
  CancelTextArea,
  CancelDropdown,
  DropdownMenuEconomic,
} from "./styles";
import {
  DropdownItemEconomic,
  DrodownButtonEconomic,
  SeccondModalButtons,
} from "~/pages/Portal/styles";
import { InfoButton, InfoButtonDisabled } from "~/components/layout/Buttons";
import api from "~/services/api";
import check from "~/assets/images/check.svg";
import close from "~/assets/images/close.svg";

export default function CancelOrder({ buttonCanceledShow, orderSelected }) {
  const dispatch = useDispatch();
  const orderCanceled = useSelector((state) => state.statusReducer.cancelOrder);

  const [showModal, setShowModal] = useState(false);
  const [secondModal, setSecondModal] = useState(false);
  const [confirmCanceling, setConfirmCanceling] = useState(false);
  const [viewTextarea, setViewTextarea] = useState(false);
  const [writingTextarea, setWritingTextarea] = useState("");
  const [textMotivation, setTextMotivation] = useState("inicio");
  const [expand, setExpand] = useState(false);

  let addressComponent = React.createRef();
  let DropdownItemEconomicStyle = DropdownItemEconomic;
  const cardGroupEconomic = React.forwardRef(({ children, onClick }, ref) => {
    DropdownItemEconomicStyle = {
      ...DropdownItemEconomicStyle,
      minWidth: addressComponent.current
        ? addressComponent.current.offsetWidth
        : null,
    };

    return (
      <div ref={addressComponent}>
        <CancelDropdown
          ref={ref}
          onClick={(event) => {
            event.preventDefault();
            onClick(event);
            setExpand(!expand);
          }}
        >
          {writingTextarea !== "" ? (
            <span>{writingTextarea}</span>
          ) : (
              <span style={{ color: "#808080" }}>Nos conte o que aconteceu</span>
            )}
          {expand ? (
            <ExpandLessIcon style={{ color: "#808080" }} />
          ) : (
              <ExpandMoreIcon style={{ color: "#808080" }} />
            )}
        </CancelDropdown>
      </div>
    );
  });

  const cancelOrder = () => {
    dispatch({ type: "LOADING_CANCEL", loadingCancel: true });
    const urlCancel = `/residential/order/v1/orders-ga/${orderSelected.id}`;
    const body = {
      cancellationReason: writingTextarea,
      cancellationReasonDetail:
        writingTextarea === "Outro" ? textMotivation : writingTextarea,
    };
    api
      .patch(urlCancel, body, {
        headers: {
          "Content-Type": "application/json",
          access_token: localStorage.getItem("access_token"),
        },
      })
      .then((res) => {
        dispatch({ type: "CANCELED_ORDER", cancelOrder: true });
        dispatch({ type: "LOADING_CANCEL", loadingCancel: false });
        setShowModal(false);
      })
      .catch((err) => {
        setShowModal(false);
        if (err.response.status === 422) {
          toast.error(err.response.data.message);
        }
      });
  };

  return (
    <>
      <Modal
        show={secondModal}
        onHide={() => {
          setSecondModal(false);
        }}
        className="confirm-cancelling"
      >
        <Modal.Body>
          <div>
            <div>
              <span>Tem certeza que deseja fechar?</span>
            </div>
            <SeccondModalButtons>
              <Button
                style={{ marginRight: ".7rem", padding: "0 1rem" }}
                variant="secondary"
                onClick={() => {
                  setWritingTextarea("");
                  setTextMotivation("inicio");
                  setConfirmCanceling(false);
                  setViewTextarea(false);
                  setSecondModal(false);
                  setShowModal(false);
                }}
              >
                Sim
              </Button>
              <Button
                variant="primary"
                onClick={() => setSecondModal(false)}
                style={{ marginRight: ".7rem", padding: "0 1rem" }}
              >
                Não
              </Button>
            </SeccondModalButtons>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showModal}
        onHide={() => {
          confirmCanceling ? setSecondModal(true) : setShowModal(false);
        }}
        className="modal-cancel"
        centered
      >
        <Modal.Body>
          {confirmCanceling ? (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <CloseIcon
                  style={{ color: "#000FFF", cursor: "pointer" }}
                  onClick={() => {
                    setSecondModal(true);
                  }}
                />
              </div>
              <TextCancel margin={".5rem 0 1rem 0"}>
                Seu pedido será cancelado!
              </TextCancel>
              <Dropdown onToggle={(isOpen) => {
                if (!isOpen) {
                  setExpand(!expand);
                }
              }}>
                <Dropdown.Toggle
                  id="dropdown-custom-components"
                  as={cardGroupEconomic}
                  style={DrodownButtonEconomic}
                ></Dropdown.Toggle>
                <DropdownMenuEconomic style={{left: 0.5}}>
                  <Dropdown.Item
                    onClick={() => {
                      setViewTextarea(false);
                      setWritingTextarea("Quantidade errada");
                    }}
                    style={DropdownItemEconomicStyle}
                    key={1}
                  >
                    Quantidade errada
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setViewTextarea(false);
                      setWritingTextarea("Produto errado");
                    }}
                    style={DropdownItemEconomicStyle}
                    key={1}
                  >
                    Produto errado
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setViewTextarea(false);
                      setWritingTextarea("Data de solicitação errada");
                    }}
                    style={DropdownItemEconomicStyle}
                    key={1}
                  >
                    Data de solicitação errada
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setViewTextarea(true);
                      setWritingTextarea("Outro");
                      setTextMotivation("");
                    }}
                    style={DropdownItemEconomicStyle}
                    key={1}
                  >
                    Outro
                  </Dropdown.Item>
                </DropdownMenuEconomic>
              </Dropdown>
              {viewTextarea ? (
                <CancelTextArea
                  maxLength="255"
                  placeholder="Nos conte o que aconteceu"
                  onChange={(e) => setTextMotivation(e.target.value)}
                />
              ) : null}
              {writingTextarea !== "" && textMotivation !== "" ? (
                <InfoButton
                  style={{ width: "90%" }}
                  margin={"1rem 1rem 2rem 1rem"}
                  onClick={() => cancelOrder()}
                >
                  Confirmar
                </InfoButton>
              ) : (
                  <InfoButtonDisabled
                    style={{ width: "90%" }}
                    margin={"1rem 1rem 2rem 1rem"}
                    disabled
                  >
                    Confirmar
                  </InfoButtonDisabled>
                )}
            </div>
          ) : (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <CloseIcon
                    style={{ color: "#000FFF", cursor: "pointer" }}
                    onClick={() => {
                      setShowModal(false);
                    }}
                  />
                </div>
                <TextCancel margin={"1.5rem 0 3rem 0"}>
                  Deseja cancelar seu pedido?
              </TextCancel>
                <AlignButtonsCancel>
                  <ButtonCancelYes onClick={() => setConfirmCanceling(true)}>
                    <>
                      <img src={check} alt="Ícone" />
                      <span>Sim</span>
                    </>
                  </ButtonCancelYes>
                  <ButtonCancelNo onClick={() => setShowModal(false)}>
                    <>
                      <img src={close} alt="Ícone" />
                      <span>Não</span>
                    </>
                  </ButtonCancelNo>
                </AlignButtonsCancel>
              </div>
            )}
        </Modal.Body>
      </Modal>
      {orderCanceled ||
        buttonCanceledShow ||
        orderSelected.status === "CANCELADO" ? null : (
          <div style={{
            display: 'flex',
            justifyContent: 'center'
          }}>
            <CancelButton
              onClick={() => {
                setShowModal(true);
              }}
            >
              Cancelar pedido
            </CancelButton>
          </div>
        )}
    </>
  );
}
